<script type="ts">
    import { Localized } from '@nubolab-ffwd/svelte-fluent';
    import { stores } from "@nubolab-ffwd/svelte-fluent/src/internal/FluentProvider.svelte";
    import { getLocalizedValue } from '../helpers';

    const { getTranslation } = stores();

    let langCode = $getTranslation("language-code").value;

    export let onClick: (item: InventoryItem) => void;
    export let item: InventoryItem;
</script>

<article on:click={(ev) => onClick && onClick(item)}>
    <img src={`img/thumbnail/${item.type}.jpg`} alt={`${getLocalizedValue(item, "name", langCode)} Thumbnail`} />
    <h3>{getLocalizedValue(item, "name", langCode)}</h3>
    {#if item.width || item.depth || item.height}
    <ul>
        <li><Localized id="inventory-width" args={{value: item.width}} /></li>
        <li><Localized id="inventory-depth" args={{value: item.depth}} /></li>
        <li><Localized id="inventory-height" args={{value: item.height || item.variants?.map(v => v.height).join(', ')}} /></li>
    </ul>
    {/if}
</article>

<style type="text/scss">
    article {
        display: grid;
        grid-template-columns: 100px auto;
        grid-template-rows: auto auto;
        cursor: pointer;
        transition: all .3s ease-in-out;
        background-color: #fff;
        padding: .75rem 1rem;
        will-change: filter;

        &:hover {
            filter: brightness(.95);
        }
    }

    img {
        grid-row: span 2;
        max-width: 100%;
    }

    h3 {
        grid-column: 2;
        padding: 0 0 0 .5rem;
        font-size: 1.125rem;
        line-height: 1.1;
        font-weight: bold;
    }
    
    ul {
        grid-column: 2;
        list-style: none;
        margin: 0;
        padding: 0 0 0 .5rem;

        li {
            margin: .375rem 0;
        }
    }
</style>